import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MenuAction, RequestAction } from 'src/app/core/models/calendar.model';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { emailRegex } from 'src/app/core/constants/consts';
import { removeCaracter } from 'src/app/core/constants/properties-const';

@Component({
  selector: 'app-calendar-mark',
  templateUrl: './calendar-mark.component.html',
  styleUrls: ['./calendar-mark.component.scss']
})
export class CalendarMarkComponent implements OnInit {

  public listActions: MenuAction [] = [
    {
      select: false,
      text: 'Evento'
    },
    {
      select: false,
      text: 'Tarefa'
    },
    {
      select: false,
      text: 'Lembrete'
    },
    {
      select: false,
      text:'Retorno'
    },
    {
      select: false,
      text: 'Visita'
    }
  ];

  public listStage: string [] = ['Sem atendimento', 'Sem contato', 'Em atendimento', 'Visita', 'Proposta', 'Venda'];
  public contactList: string [] = ['Telefone', 'Email', 'WhatsApp', 'Pombo-correio'];
  public timeList: string [] = ['Minutos antes', 'Horas antes', 'Dias antes', 'Semanas antes'];
  public eventsActions: string [] = ['Não se repete', 'Todos os dias', 'Toda semana (quarta-feira)', 'Todo mês (todo dia 12)', 'Todo ano (12 de agosto)', 'Dias úteis (seg. a sex.)'];

  public id_type = null;
  
  @Input() public open = false;
  @Input() public requestData = {
    day: null,
    month: null
  };
  @Output() public close = new EventEmitter<boolean>();

  public emailRegex = emailRegex;
  public formCalendar: FormGroup;
  public textSearching = '';

  public removeCaracter = removeCaracter;


  constructor(
    private scroll: WindowScrollService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initializeEvents();
    this.listActions[0].select = true;
    this.id_type = 0;
    this.scroll.disable();
  }

  private initializeEvents() {
    this.formCalendar = this.formBuilder.group({
      title: ['',[Validators.required]],
      day: [this.requestData.day,[Validators.required]],
      mounth: [this.requestData.month,[Validators.required]],
      type_select: [null,[Validators.required]],
      date: [null,[Validators.required]],
      hour: [null,[Validators.required]],
      event_notofication: [null,[Validators.required]],
      notification_time: [null,[Validators.required]],
      time_repeat: [null,[Validators.required]],
      location: [null,[Validators.required]],
      invaits: [[],[Validators.required]],
      description: [null,[Validators.required]],
      link_facs: [null, [Validators.required]],
      stage_attendance: [null, [Validators.required]],
      type_contact: [null, [Validators.required]],
    });
  }

  public actionButtons(data: RequestAction): void {
    this.id_type = data.index;
  }

  public closeModal(): void {
    this.scroll.enable();
    this.open = false;
    this.close.emit(this.open);
  }

  public sendSearch(event: string): void {
    if (event === 'Visita') {
      this.listActions.forEach(x => x.select = false);
      this.listActions[4].select = true;
      this.id_type = 4;
      this.textSearching = this.listStage[3];
    } else {
      this.textSearching = event;
    }
  }

  public getTags(tag: string []): void {
    this.formCalendar.get('invaits').setValue(tag);
  }

}
